import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import Location from '../components/Location/index'

class AddLocationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      locationId: '',
    };
  }

  componentDidUpdate(prevProps) {
    const { formData } = this.props;
    if (formData && prevProps.formData !== formData) {
      this.setState({
        name: formData.locationName || '',
        locationId: formData.locationId || '',
        _id: formData._id,
      });
    }
  }

  onAddedLocationChange = ev => {
    const { name, value } = ev.target;
    this.setState({ [name]: value });
  };

  onConfirmAddress = ev => {
    const { onConfirm } = this.props;
    const payload = { ...this.state };
    onConfirm(payload);
  }

  getLocationInfo = ev => {
    this.setState({
      address: ev?.address,
      city: ev?.city,
      state: ev?.state,
      zip: ev?.zip,
      lat: ev?.lat,
      lng: ev?.lng,
      country: ev?.country,
    })
  }

  render() {
    const { isOpen, onCancel, disabled, formData } = this.props;

    return (
      <Modal isOpen={isOpen}>
        {!disabled && <ModalHeader>Add New Location</ModalHeader>}
        <ModalBody>
          <div className="container">
            <FormGroup row>
              <Label for="name" sm={4}>
                Location Name:
              </Label>
              <Col sm={12}>
                <Input
                  disabled={disabled}
                  placeholder="Please specify"
                  required
                  type="text"
                  name="name"
                  value={this.state.name}
                  onChange={this.onAddedLocationChange}
                />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="locationId" sm={4}>
                Location ID:
              </Label>
              <Col sm={12}>
                <Input
                  disabled={disabled}
                  placeholder="Please specify"
                  required
                  type="text"
                  name="locationId"
                  value={this.state.locationId}
                  onChange={this.onAddedLocationChange}
                />
              </Col>
            </FormGroup>

            <Location 
              disabled={disabled}
              boxDbLocation={formData}
              getLocationInfo={this.getLocationInfo}
              latLang
              address2={false}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>
            Cancel
          </Button>
          {!disabled && (
            <Button color="primary" onClick={this.onConfirmAddress}>
              Save
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

export default AddLocationModal;
